import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, UserPlus, ClipboardList, Settings as SettingsIcon,
  LogIn, LogOut, BookOpen,
} from "lucide-react";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";

const navItem = ({ isActive }) =>
  `flex items-center gap-2 px-4 py-2.5 rounded-md text-sm font-medium transition-all ${
    isActive
      ? "bg-white/10 text-white border-b-2 border-[#C59B27]"
      : "text-slate-200 hover:bg-white/5 hover:text-white"
  }`;

export default function Layout() {
  const { user, isAdmin, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <div className="bg-[#0B2545] border-b-4 border-[#C59B27]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
            <div className="w-14 h-14 rounded-md bg-white/95 shadow-md flex items-center justify-center p-1 shrink-0 ring-2 ring-[#C59B27]">
              <img src="/logo-seruyan.webp" alt="Logo Kabupaten Seruyan" className="w-full h-full object-contain" />
            </div>
            <div>
              <div className="text-white font-bold text-base sm:text-lg tracking-wide leading-tight">
                SEKRETARIAT DPRD
              </div>
              <div className="text-[#C59B27] text-xs sm:text-sm font-medium tracking-wider uppercase">
                {isAdmin ? "Portal Admin · Kabupaten Seruyan" : "Portal Tamu · Kabupaten Seruyan"}
              </div>
            </div>
          </Link>
          <div className="hidden md:flex items-center gap-3">
            {isAdmin ? (
              <>
                <div className="text-right">
                  <div className="text-slate-300 text-[10px] uppercase tracking-widest">Masuk sebagai</div>
                  <div className="text-white text-sm font-medium" data-testid="admin-user-email">{user?.email}</div>
                </div>
                <Button size="sm" variant="outline" onClick={() => { logout(); nav("/"); }}
                        className="border-[#C59B27] text-[#C59B27] hover:bg-[#C59B27] hover:text-[#0B2545]"
                        data-testid="logout-button">
                  <LogOut className="w-4 h-4 mr-1" /> Keluar
                </Button>
              </>
            ) : (
              <Button asChild size="sm" variant="outline"
                      className="border-[#C59B27] text-[#C59B27] hover:bg-[#C59B27] hover:text-[#0B2545]"
                      data-testid="header-login-button">
                <Link to="/login"><LogIn className="w-4 h-4 mr-1" /> Login Admin</Link>
              </Button>
            )}
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 pb-2">
          <nav className="flex flex-wrap gap-1">
            {isAdmin ? (
              <>
                <NavLink to="/admin" end className={navItem} data-testid="nav-dashboard-link">
                  <LayoutDashboard className="w-4 h-4" /> Dashboard
                </NavLink>
                <NavLink to="/admin/tamu/baru" className={navItem} data-testid="nav-visitor-form-link">
                  <UserPlus className="w-4 h-4" /> Registrasi Tamu
                </NavLink>
                <NavLink to="/admin/tamu" className={navItem} data-testid="nav-visitor-log-link">
                  <ClipboardList className="w-4 h-4" /> Buku Tamu
                </NavLink>
                <NavLink to="/admin/pengaturan" className={navItem} data-testid="nav-settings-link">
                  <SettingsIcon className="w-4 h-4" /> Pengaturan
                </NavLink>
              </>
            ) : (
              <>
                <NavLink to="/registrasi" className={navItem} data-testid="nav-public-registrasi-link">
                  <UserPlus className="w-4 h-4" /> Registrasi Tamu
                </NavLink>
                <NavLink to="/buku-tamu" className={navItem} data-testid="nav-public-buku-tamu-link">
                  <BookOpen className="w-4 h-4" /> Buku Tamu
                </NavLink>
              </>
            )}
          </nav>
        </div>
      </div>

      <main className="flex-1 max-w-7xl mx-auto w-full px-4 sm:px-6 py-6 sm:py-10 animate-fade-in-up">
        <Outlet />
      </main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 text-center text-xs text-slate-500">
          © {new Date().getFullYear()} Sekretariat DPRD Kabupaten Seruyan · Dokumentasi Resmi Kunjungan Tamu
        </div>
      </footer>
    </div>
  );
}
